import Fragment from '../../../components/Fragment'
import Division from '../../../components/Division'
import { GOOGLE_API_KEY } from '../../../constants'
import MapComponent from '../../../components/MapComponent/MapComponent'
import useStyles from '../styles'
import Story from '../../../components/Story'
import { andWhatNext } from '../../../helpers'

const SectionShowStories = ({ fragments, coords, results }) => {
  const classes = useStyles()
  const [story, setStory] = useState(null)
  const [showStory, setShowStory] = useState(false)

  const onClickStory = (id) => {
    setStory(results?.stories.filter((s) => s.id === id)[0])
    setShowStory(true)
  }

  const onClickStoryTakeAction = () => {
    window.location.href = andWhatNext('storyClick', { postcode: results.postcode })
  }

  return (
    <Grid item container>
      <Story
        show={showStory}
        onClose={() => {
          setStory(null)
          setShowStory(false)
        }}
        story={story}
        onClick={onClickStoryTakeAction}
      />
      <Grid
        item
        container
        justify="center"
        xs={12}
        className={classes.gridClear}
        style={{ padding: '50px 0' }}
      >
        <Grid item xs={12} sm={8} md={6} lg={4}>
          <Typography variant="h4" align="center">
            <Fragment title="results_section_3_title" {...{ fragments }} />
          </Typography>
          <Division padding={15} />
          <Typography variant="body1" align="center">
            <Fragment title="results_section_3_paragraph" {...{ fragments }} />
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={12} className={classes.gridMap}>
        {!!GOOGLE_API_KEY && (
          <MapComponent
            coords={coords}
            apiKey={GOOGLE_API_KEY}
            stories={results && results?.stories}
            onClickStory={onClickStory}
            fullscreen
          />
        )}
      </Grid>
    </Grid>
  )
}

export default SectionShowStories
